import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import DiscoveryFilterPreset from './components/DiscoveryFilterPreset';

export function DiscoveryFilterRoutes() {
    return <Routes>{hasAccessRight(AdminAclEnum.ADMIN) && <Route index element={<DiscoveryFilterPreset />} />}</Routes>;
}
